import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PromoBanner } from '@/models/cms';
import { CustomerProfile } from '@/models';
import { EnrollmentOptions } from '@/services/loyalty/loyalty.service';

@Component({
  name: 'CmgUnenrolledRewards',
})
export default class CmgUnenrolledRewards extends Vue {
  interval: any;

  mounted() {
    this.$router.beforeResolve((to, from, next) => {
      if (to.hash === '#enroll') {
        const enrollmentOptions: EnrollmentOptions = { customer: this.customer, pageTitle: document.title };
        this.$services.loyalty.enrollInLoyalty(enrollmentOptions);
      }

      next();
    });

    this.interval = setInterval(this.resizeIframe, 1000);
  } 

  destroyed() {
    clearInterval(this.interval);
  }

  get customer(): CustomerProfile | null {
    return this.$appStore.state.customer.profile;
  }

  get isLoggedIn() {
    return this.$services.customer.isLoggedIn() === true;
  }

  get cmsPromoBanner(): PromoBanner | null {
    if (this.isLoggedIn) {
      return this.$appStore.state.cms.promoBannerRewardsAuthenticatedNotEnrolled;
    }
    return this.$appStore.state.cms.promoBannerRewardsGuest;
  }

  get rewardsBannerUrl(): string {
    return `${window.location.origin}/experience-fragments/rewards-banner-experience-fragment/master`;
  }

  resizeIframe() {
    const iframe = this.$refs.iframe as HTMLIFrameElement;
    const iframeContainer = this.$refs.iframeContainer as HTMLElement;

    if (iframe && iframe.contentWindow) {
      const height = iframe.contentWindow.document.documentElement.offsetHeight + 'px';
      iframe.style.height = height;
      iframeContainer.style.height = height;
    }
  }
}
